module.exports = __webpack_public_path__ + "img/logo.e62a25ef.png";